import * as React from 'react';
import EmojiPicker, { EmojiClickData, EmojiStyle, Theme } from 'emoji-picker-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSmile } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'antd';
import { X } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@/shadcn/components/ui/dialog';

interface IProps {
  onEmojiSelect: (emoji: string) => void;
}

export const EmojiPickerSingle: React.FC<IProps> = ({ onEmojiSelect }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleEmojiClick = React.useCallback((emojiData: EmojiClickData) => {
    onEmojiSelect(emojiData.emoji);
    // Don't close the modal - allow multiple emoji selection
  }, [onEmojiSelect]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Tooltip title="Insert Emoji">
          <div className="flex items-center justify-center w-6 h-6 rounded cursor-pointer transition-all duration-150 hover:bg-grey-2">
            <FontAwesomeIcon icon={faSmile} className="h-3 w-3 text-primary cursor-pointer hover:bg-grey-2" />
          </div>
        </Tooltip>
      </DialogTrigger>
      <DialogContent
        className="w-auto max-w-none p-0 border-0 bg-transparent shadow-none !z-[99999] [&>button]:hidden"
        onInteractOutside={() => setIsOpen(false)}
      >
        <div className="rounded-lg border bg-white shadow-xl overflow-hidden">
          {/* Header with title and close button in flex layout */}
          <div className="flex items-center justify-between px-3 py-2 border-b bg-gray-50">
            <span className="text-sm font-medium text-gray-700">Select Emoji</span>
            <button
              type="button"
              className="h-7 w-7 p-0 hover:bg-gray-200 rounded inline-flex items-center justify-center"
              onClick={() => setIsOpen(false)}
              aria-label="Close emoji picker"
            >
              <X className="h-4 w-4" />
            </button>
          </div>

          <EmojiPicker
            onEmojiClick={handleEmojiClick}
            emojiStyle={EmojiStyle.NATIVE}
            theme={Theme.LIGHT}
            previewConfig={{
                showPreview: false
              }}
            width={300}
            height={350}
            searchDisabled={false}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
